module.exports = __webpack_public_path__ + "static/media/pexels.com-2785533.dfaa7386.mp4";